export default {
  state: {
    api: [],
    fields: {
      courierAddressField: false,
      addressField: {
        COUNTRY: null,
        AREA: null,
        CITY: null,
        STREET: null,
        BUILD: null,
        CORPUS: null,
        POSTINDEX: null,
        APARTMENT: null,
        FLOOR: null,
        ENTRANCE: null,
        INTERCOM: null,
      },
    },
    // additional fields errors
    additionalFields: {
      courierAddressField: false,
      userField: {
        FAKTURA_COMPANY: null,
        FAKTURA_INN: null,
        FAKTURA_POSTINDEX: null,
        FAKTURA_CITY: null,
        FAKTURA_ADDRESS: null,
        FAKTURA_FIO: null,
      },
    },
  },
  mutations: {
    addApiError: (state, error) => {
      state.api.push(error)
    },
    setApiErrors: (state, errors) => (state.api = errors),
    resetApiErrors: (state) => (state.api = []),
    setCourierAddressFieldError: (state, error) =>
      (state.fields.courierAddressField = error),
    setFieldError: (state, { field, error }) =>
      (state.fields.addressField[field] = error),

    setCourierAddressAdditionalFieldError: (state, error) => {
      state.additionalFields.courierAddressField = error
    },
    setUserAdditionalFields: (state, { field, error }) => {
      state.additionalFields.userField[field] = error
    },
  },
  getters: {
    apiErrors: (state) => state.api,
    hasApiError: (state) => !!state.api.length,
    courierAddressFieldError: (state) => state.fields.courierAddressField,
    addressFieldErrors: (state) => state.fields.addressField,
    // additional fields errors
    userAdditionalFields: (state) => state.additionalFields.userField,
  },
}
